module.exports = __webpack_public_path__ + "assets/webgl/art_083_L0.f9f5abb5.jpg";